import SurveyCompleted from './SurveyCompleted';

export default SurveyCompleted;


// WEBPACK FOOTER //
// /src/components/commonComponents/surveyView/surveyCompleted/index.js